import { gql } from "@apollo/client";

// ─── Queries ─────────────────────────────────────────────────────────────────

export const ORGANIZATION_ROSTER = gql`
  query OrganizationRoster(
    $organizationId: ID!
    $input: OrganizationRosterInput
  ) {
    organizationRoster(organizationId: $organizationId, input: $input) {
      items {
        _id
        organizationId
        workEmail
        firstName
        lastName
        jobTitle
        department
        employeeStatus
        employeeId
        enrollmentStatus
        createdAt
        updatedAt
      }
      total
      hasMore
    }
  }
`;

export const ORGANIZATION_ROSTER_STATS = gql`
  query OrganizationRosterStats($organizationId: ID!) {
    organizationRosterStats(organizationId: $organizationId) {
      totalEntries
      activeUsers
      pendingInvites
      notInvited
    }
  }
`;

export const ORGANIZATION_SEAT_USAGE = gql`
  query OrganizationSeatUsage($id: ID!) {
    organization(id: $id) {
      _id
      seatUsage {
        used
        limit
        percentage
        status
      }
    }
  }
`;

// ─── Export (fetches all rows for CSV download) ─────────────────────────────

export const EXPORT_ORGANIZATION_ROSTER = gql`
  query ExportOrganizationRoster(
    $organizationId: ID!
    $input: OrganizationRosterInput
  ) {
    organizationRoster(organizationId: $organizationId, input: $input) {
      items {
        workEmail
        firstName
        lastName
        jobTitle
        department
        employeeStatus
        employeeId
        enrollmentStatus
        createdAt
      }
      total
    }
  }
`;

// ─── Mutations ───────────────────────────────────────────────────────────────

export const BULK_IMPORT_USERS = gql`
  mutation BulkImportUsers(
    $organizationId: ID!
    $file: Upload!
    $input: BulkImportUsersInput
  ) {
    bulkImportUsers(
      organizationId: $organizationId
      file: $file
      input: $input
    ) {
      successCount
      skippedCount
      errorCount
      errors {
        row
        error
      }
      warnings
      skippedRows
    }
  }
`;

export const SEND_ROSTER_INVITES = gql`
  mutation SendRosterInvites($organizationId: ID!, $emails: [String!]!) {
    sendRosterInvites(organizationId: $organizationId, emails: $emails) {
      sent
      alreadyRegistered
      failed
    }
  }
`;
